var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "136px",
    viewBox: "0 0 129 136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0352229,16.1655206 C65.0377737,11.6391041 70.8013887,8.796075 77.2059311,8.79111116 C89.2820428,8.78177032 99.0638749,18.8662004 99.0542716,31.3153227 C99.0483451,38.9833502 95.3332575,44.9256666 89.6510014,49.8363059 C87.1292331,52.015633 77.5764788,59.1377467 60.9927384,71.2026472 C44.4276026,59.1634051 34.8858314,52.0560712 32.3674249,49.8806454 C26.6927436,44.9787968 22.9868261,39.0422245 22.9927384,31.374197 C23.0023558,18.9250747 32.7997693,8.82548958 44.8758809,8.81614225 C51.2804233,8.81118491 57.0396558,11.6452949 61.0352229,16.1655206 Z",
    id: "Path",
    fill: "#29CCC7",
    transform: "translate(61.023505, 39.996879) rotate(-15.000000) translate(-61.023505, -39.996879) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2540692,104.79388 L40.2645531,104.793872 C47.4268405,104.788077 53.2377193,110.589561 53.2435141,117.751848 C53.2435198,117.758841 53.2435198,117.765835 53.2435141,117.772828 L53.2434959,117.795366 C53.2376963,124.966854 47.4255058,130.779046 40.2540181,130.784849 L40.2435342,130.784857 C33.0812468,130.790652 27.270368,124.989169 27.2645732,117.826881 C27.2645675,117.819888 27.2645675,117.812894 27.2645732,117.805901 L27.2645914,117.783363 C27.270391,110.611875 33.0825816,104.799683 40.2540692,104.79388 Z",
    id: "Rectangle-Copy-21",
    fill: "#A2E3FF",
    transform: "translate(40.254044, 117.789365) rotate(-217.000000) translate(-40.254044, -117.789365) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-23",
    fill: "#E4F7FF",
    transform: "translate(115.978815, 40.630628) rotate(118.000000) translate(-115.978815, -40.630628) ",
    points: "95.9830712 37.6477184 135.978741 37.6198296 135.974558 43.6135368 95.9788879 43.6414255"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-22",
    fill: "#FF9A28",
    transform: "translate(23.120376, 81.194405) rotate(-176.000000) translate(-23.120376, -81.194405) ",
    points: "0.152485668 78.1909506 46.0875639 78.1963346 46.0882662 84.1978603 0.153187934 84.1924763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.670542,82.5019002 L118.329499,93.6327694 C118.981347,94.7223744 118.626474,96.1341009 117.536869,96.7859488 C117.17967,96.9996404 116.771157,97.1123472 116.354918,97.1120437 L103.053213,97.1023461 C101.783511,97.1014204 100.754964,96.0713729 100.75589,94.8016706 C100.756192,94.3871073 100.868586,93.9803397 101.081171,93.6244323 L107.723919,82.5032607 C108.375016,81.4132065 109.786497,81.0573609 110.876552,81.7084574 C111.202708,81.9032725 111.475502,82.1758785 111.670542,82.5019002 Z",
    id: "Triangle-Copy-2",
    fill: "#FFB628",
    transform: "translate(109.709136, 88.158243) rotate(-330.000000) translate(-109.709136, -88.158243) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape02);
export default __webpack_public_path__ + "static/media/shape02.3fd7542edc370067818b94ec27f06ff5.svg";
export { ForwardRef as ReactComponent };